import React from "react";
import { decimalTo } from '../../utils/utils';

export const monthlySalesReportDataColumn = (region) => [
  {
    name: 'S.No',
    cell: (_, index) => <span>{index + 1}</span>,
    ignoreRowClick: true,
    button: true,
  },
  {
    name: 'Merchent Name',
    selector: (row) => row.merchentname,
    cell: (row) =>
      row.merchentname ? (
        <span className="add-ellip">{row.merchentname}</span>
      ) : (
        ''
      ),
  },
  {
    name: 'Total Sales',
    selector: (row) => row.orderamount,
    cell: (row) =>
      row.orderamount ? (
        <span className="add-ellip">{decimalTo(row.orderamount).toFixed(2)}</span>
      ) : (
        '0.00'
      ),
  },
  {
    name: 'Total Margin',
    selector: (row) => row.productmargin,
    cell: (row) =>
      row.productmargin ? (
        <span className="add-ellip">{decimalTo(row.productmargin).toFixed(2)}</span>
      ) : (
        '0.00'
      ),
  },
  {
    name: `Net Amount${region?.currency ? ` (${region.currency})` : ''}`,
    selector: (row) => row.productamount,
    cell: (row) => {
      const prodAmt = row.productamount || 0;
      return <span className="add-ellip">{decimalTo(prodAmt).toFixed(2)}</span>;
    },
  },
];
